var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8588_2753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80994 19.0669V43.6531C5.80994 45.2337 6.63784 46.6637 8.01768 47.4665L29.3174 59.7596C30.6721 60.5374 32.353 60.5374 33.7078 59.7596L55.0075 47.4665C56.3623 46.6888 57.2152 45.2337 57.2152 43.6531V19.0669C57.2152 17.4864 56.3873 16.0563 55.0075 15.2535L33.7078 2.9604C32.353 2.18267 30.6721 2.18267 29.3174 2.9604L8.01768 15.2535C6.66293 16.0312 5.83502 17.4864 5.83502 19.0669H5.80994Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1413 36.1268L33.1056 44.456C33.0304 44.6818 33.0304 44.9327 33.1056 45.1836L38.3239 59.5088L44.3702 56.0216L37.1197 36.1268C36.9441 35.6752 36.3169 35.6752 36.1413 36.1268Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2377 22.1276C42.0621 21.6761 41.4349 21.6761 41.2593 22.1276L38.2236 30.4569C38.1484 30.6827 38.1484 30.9335 38.2236 31.1844L46.7786 54.6417L52.8248 51.1545L42.2377 22.1527V22.1276Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 3.88864C31.6505 3.88864 31.8011 3.93882 31.9265 4.01408L54.9573 17.3107C55.2333 17.4612 55.3838 17.7623 55.3838 18.0634V44.6566C55.3838 44.9577 55.2082 45.2588 54.9573 45.4093L31.9265 58.7059C31.8011 58.7812 31.6505 58.8314 31.5 58.8314C31.3495 58.8314 31.199 58.7812 31.0735 58.7059L8.04274 45.4093C7.76677 45.2588 7.61624 44.9577 7.61624 44.6566V18.0383C7.61624 17.7372 7.79186 17.4362 8.04274 17.2856L31.0735 3.98899C31.199 3.91373 31.3495 3.86355 31.5 3.86355V3.88864ZM31.5 0C30.6721 0 29.8693 0.200704 29.1167 0.6272L6.08587 13.9238C4.60568 14.7768 3.70251 16.3323 3.70251 18.0383V44.6316C3.70251 46.3375 4.60568 47.893 6.08587 48.746L29.1167 62.0426C29.8442 62.4691 30.6721 62.6698 31.5 62.6698C32.3279 62.6698 33.1307 62.4691 33.8834 62.0426L56.9142 48.746C58.3944 47.893 59.2975 46.3375 59.2975 44.6316V18.0383C59.2975 16.3323 58.3944 14.7768 56.9142 13.9238L33.8583 0.6272C33.1307 0.200704 32.3028 0 31.4749 0H31.5Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2465 54.6668L18.379 48.8464L22.644 52.3838L18.655 56.0466L16.2465 54.6668Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5432 16.1566H23.6977C23.2712 16.1566 22.8698 16.4326 22.7192 16.834L10.2003 51.1544L16.2465 54.6416L30.0449 16.834C30.1704 16.4828 29.9195 16.1315 29.5683 16.1315L29.5432 16.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7791 16.1566H33.9336C33.5071 16.1566 33.1057 16.4326 32.9551 16.834L18.655 56.0215L24.7012 59.5087L40.2557 16.834C40.3812 16.4828 40.1303 16.1315 39.7791 16.1315V16.1566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8588_2753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.72,
    height: 62.72,
    fill: "white",
    transform: "translate(0.140015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.d49e3e030113fd3bf7579bb6ebc60448.svg";
export { ForwardRef as ReactComponent };